<div class="bg-white rounded-2xl shadow-2xl overflow-hidden w-full max-w-lg mx-auto flex flex-col max-h-[92vh]">
  <!-- Header -->
  <div class="px-6 py-4 border-b border-gray-100 flex items-center justify-between shrink-0">
    <div class="flex items-center gap-3">
      <div class="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shrink-0 shadow-sm">
        <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>
      </div>
      <div>
        <h2 class="text-lg font-bold text-gray-900 leading-tight">New phase template</h2>
        <p class="text-xs text-gray-400">Reusable phases for new projects</p>
      </div>
    </div>
    <button type="button" (click)="close.emit()" class="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
    </button>
  </div>

  <form (ngSubmit)="onSubmit()" #phaseForm="ngForm" class="flex flex-col flex-1 min-h-0">
    <div class="px-6 py-5 space-y-5 overflow-y-auto flex-1 min-h-0 bg-gray-50/40 custom-scrollbar">
      <div class="flex flex-col">
        <label class="text-xs text-gray-500 font-semibold mb-1.5 uppercase tracking-wide">Model name</label>
        <input type="text" [(ngModel)]="phaseModelData.modelName" name="modelName" required placeholder="Enter model name"
          class="border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-400 transition" />
      </div>

      <div class="rounded-xl border border-gray-200 bg-white p-4 space-y-2.5">
        <div class="flex items-center gap-1.5 text-xs text-gray-400 font-bold uppercase tracking-wider mb-1">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h7" /></svg>
          Phases
        </div>
        @for (phase of phaseModelData.phases; track $index) {
        <div class="flex flex-col gap-2 p-2.5 border border-gray-100 rounded-lg bg-gray-50/60">
          <div class="flex items-center gap-2">
            <span class="relative w-8 h-8 shrink-0">
              <span class="absolute inset-0 rounded-lg ring-2 ring-white shadow-sm" [style.background]="phase.color"></span>
              <input type="color" [(ngModel)]="phase.color" name="phaseColor{{ $index }}" class="absolute inset-0 opacity-0 cursor-pointer w-full h-full" title="Phase color" />
            </span>
            <input type="text" [(ngModel)]="phase.name" name="phaseName{{ $index }}" required placeholder="Phase name"
              class="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition" />
            <button type="button" (click)="removePhase($index)" class="w-8 h-8 rounded-lg text-gray-400 hover:bg-red-50 hover:text-red-500 transition-all cursor-pointer flex items-center justify-center shrink-0">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
            </button>
          </div>
          <div class="flex items-center gap-2 pl-10">
            <label class="text-xs font-semibold text-gray-500">Est. hours</label>
            <input type="number" [(ngModel)]="phase.estimatedHours" name="phaseHours{{ $index }}" min="0" step="0.5" placeholder="e.g. 10"
              class="w-24 border border-gray-300 rounded-lg px-2 py-1.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition" />
          </div>
        </div>
        }
        <button type="button" (click)="addPhase()" class="inline-flex items-center gap-1 text-blue-600 font-semibold text-sm hover:text-blue-700 cursor-pointer pt-1">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" /></svg>
          Add phase
        </button>
      </div>
    </div>

    <div class="px-6 py-3.5 border-t border-gray-100 flex justify-end gap-2 bg-gray-50/50 shrink-0">
      <button type="button" (click)="close.emit()" class="px-4 py-2.5 text-gray-700 text-sm font-medium hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">Cancel</button>
      <button type="submit" [disabled]="!phaseForm.form.valid || isSubmitting"
        class="bg-blue-600 text-white text-sm font-semibold py-2.5 px-5 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm cursor-pointer">
        {{ isSubmitting ? 'Creating…' : 'Create template' }}
      </button>
    </div>
  </form>
</div>
